{
  "password-form": {
    "text": {
      "password": "Password",
      "password-confirmation": "Password confirmation"
    }
  }
}
